import Search from "./search";
import DataList from "./data_list";
import { useViewListFilter } from "../../../hooks/order_list_views/useViewListFilter.hook";

export default function GeneralViewPanel(){

    const hook = useViewListFilter();
    

    if(hook.panel === 'search'){
        return(
            <Search hook={hook} changePanel={() => hook.setPanel('data')} />
        );
    } else {
        return(
            <DataList hook={hook} changePanel={() => hook.setPanel('search')} />
        );
    }
}